
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->






<div class="connection-indicator" [class.offline]="!isInternetOnline" [title]="isInternetOnline ? 'Internet Connecté' : 'Pas de connexion Internet'">
   <mat-icon class="status-icon">{{ isInternetOnline ? 'wifi' : 'wifi_off' }}</mat-icon>
   <span class="text">{{ isInternetOnline ? 'En Ligne' : ('Hors Ligne' + (offlineCount > 0 ? ' (' + offlineCount + ')' : '')) }}</span>
</div>

<ng-container>
  <button [matMenuTriggerFor]="options" mat-icon-button class="m-r-5" > 
    <img [src]="translateImageBase64 || 'assets/images/translate.png'" alt="user" class="profile-pic">
   </button>
</ng-container>

<mat-menu #options="matMenu" >
  <button mat-menu-item (click)="changeLanguage('en')"><img [src]="englishFlagBase64" alt="en" width="18px"> {{'english' | translate}} </button>
  <button mat-menu-item (click)="changeLanguage('fr')"><img [src]="frenchFlagBase64 || 'assets/images/french.jpg'" alt="fr" width="18px"> {{'french' | translate}}</button>
</mat-menu>

<ng-container *ngIf="countlogs>0">
  <button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5" [matBadge]="countlogs" matBadgePosition="after" matBadgeColor="warn"> <ng-container *ngIf="picture ==null || picture ==''"><img [src]="profileImageBase64 || 'assets/images/profile.jpg'" alt="user" class="profile-pic"></ng-container>
    <ng-container *ngIf="picture !=null && picture !=''"><img [src]="picture" alt="user" class="profile-pic"></ng-container>
   </button>
</ng-container>



<ng-container *ngIf="countlogs==0">
  <button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5"> <ng-container *ngIf="picture ==null || picture ==''"><img [src]="profileImageBase64 || 'assets/images/profile.jpg'" alt="user" class="profile-pic"></ng-container>
    <ng-container *ngIf="picture !=null && picture !=''"><img [src]="picture" alt="user" class="profile-pic"></ng-container>
   </button>
</ng-container>

<mat-menu #profile="matMenu" class="mymegamenu">

    <button routerLink="/door" mat-menu-item>
      <mat-icon>apps</mat-icon> {{'Portail Principal' | translate}} 
    </button>

    <button (click)="viewProfil()" mat-menu-item>
      <mat-icon>account_box</mat-icon> Profile 
    </button>
    

    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon> 
      {{'logout' | translate}} 
    </button>

    <button mat-menu-item (click)="closesession()">
      <mat-icon>logout</mat-icon> 
      {{'closesession' | translate}} 
    </button>

</mat-menu>

